var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "div",
      { class: `name-${_vm.name}` },
      [
        _vm.name === "DotCircle"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "dot-circle",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "Bullseye"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "bullseye",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M256 72c101.689 0 184 82.295 184 184 0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-101.689 82.295-184 184-184m0-64C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 184c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64m0-64c-70.692 0-128 57.308-128 128s57.308 128 128 128 128-57.308 128-128-57.308-128-128-128z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "SquareFull"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "square-full",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: { fill: "currentColor", d: "M512 512H0V0h512v512z" },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "Star"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "star",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 576 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "ChevronLeft"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "chevron-left",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 320 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "ChevronDown"
          ? [
              _c(
                "svg",
                {
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "chevron-down",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "ChevronRight"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "chevron-right",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 320 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "AngleDoubleLeft"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "angle-double-left",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "AngleDoubleRight"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "angle-double-right",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "CaretLeft"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "caret-left",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 192 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "CaretRight"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "caret-right",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 192 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "CheckCircle"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "check-circle",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "ArrowAltCircleRight"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "arrow-alt-circle-right",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "ArrowAltCircleLeft"
          ? [
              _c(
                "svg",
                {
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "true",
                    "data-prefix": "fas",
                    "data-icon": "arrow-alt-circle-left",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "Circle"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fas",
                    "data-icon": "circle",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }